module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "list-item def arr-row record-item",
    on: {
      "click": function($event) {
        return _vm.goCharacter()
      }
    }
  }, [_vm._v("\n        个人健康特征\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "list-item def arr-row record-item",
    on: {
      "click": function($event) {
        return _vm.goVisit()
      }
    }
  }, [_vm._v("\n        就诊记录\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "list-item def arr-row record-item",
    on: {
      "click": function($event) {
        return _vm.goPhysicalExam()
      }
    }
  }, [_vm._v("\n        体检\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb637ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/RecordSelect.vue
// module id = 847
// module chunks = 0